import { render, staticRenderFns } from "./SingedComponent.vue?vue&type=template&id=67bd2eb5"
import script from "./SingedComponent.vue?vue&type=script&lang=js"
export * from "./SingedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports